import Tracker from './pages/Tracker';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <Tracker/>
  );
}

export default App;
